import { Button } from "@/components/bnp-ui";
import { BNPModal } from "@/components/bnp-ui/overlays/BNPModal";
import { ProfileDelete } from "@/components/bnp-icons";
import { BusinessDocument } from "@/types/business";

interface DeleteDocumentModalProps {
  document: BusinessDocument | null;
  isPending: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteDocumentModal = ({
  document,
  isPending,
  onConfirm,
  onClose,
}: DeleteDocumentModalProps) => {
  return (
    <BNPModal
      isOpen={!!document}
      onClose={() => {
        if (!isPending) onClose();
      }}
      maxWidth="max-w-md"
    >
      <div className="p-7">
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-2xl bg-rose-50 flex items-center justify-center text-rose-600 shrink-0">
            <ProfileDelete active width={22} height={22} />
          </div>
          <div>
            <h3 className="text-slate-900 font-bold text-base">
              Delete this document?
            </h3>
            <p className="text-xs text-slate-400 mt-1.5 leading-relaxed">
              You are about to permanently delete your{" "}
              <span className="font-bold text-slate-600">
                {document?.type.toUpperCase()}
              </span>{" "}
              document (ID: {document?.identification_number}). This action
              cannot be undone.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-6 mt-6 border-t border-slate-100">
          <Button
            className="h-11 px-5 bg-[#F4F6FA] text-slate-600 text-sm font-semibold rounded-xl hover:bg-[#E8ECF1] transition-colors"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            className="h-11 px-5 bg-rose-600 hover:bg-rose-700 text-white text-sm font-semibold rounded-xl shadow-md shadow-rose-600/20 transition-all"
            onClick={onConfirm}
            disabled={isPending}
            isLoading={isPending}
          >
            {isPending ? "Deleting..." : "Yes, delete document"}
          </Button>
        </div>
      </div>
    </BNPModal>
  );
};

export default DeleteDocumentModal;
